import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

/* eslint jsx-a11y/no-redundant-roles: 0 */
import React, { Component } from 'react';
import classNames from 'classnames';
import Container from "@scentregroup/ui/components/container";
import Heading from "@scentregroup/ui/components/heading";
import { uniqueId } from 'lodash';
import DeckScrollWrapper from '../deck-scroll-wrapper';
import analyticsUtils from '../../helpers/analytics-utils';
import { CONFIG_KEYS, getClientConfigBool } from '../../config';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

class FeaturedContent extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "trackVisibleItems", items => {
      const cards = items.map(c => c.props); // Minimum acceptable number of Featured content items

      const minRequiredVisibleItems = 4;
      const promotions = cards.slice(0, minRequiredVisibleItems).map(i => ({
        id: i.id,
        name: i.title,
        position: analyticsUtils.positions.FEATURED_CONTENT,
        dimension90: analyticsUtils.dimensions.DIMENSION90,
        creative: i.body
      }));
      analyticsUtils.gaTagTracking({
        event: analyticsUtils.events.PROMOTION_IMPRESSION,
        ecommerce: {
          promoView: {
            promotions
          }
        }
      });
    });

    _defineProperty(this, "trackClickEvent", item => {
      analyticsUtils.gaTagTracking({
        event: analyticsUtils.events.PROMOTION_CLICK,
        ecommerce: {
          promoClick: {
            promotions: {
              id: item.id,
              name: item.title,
              position: analyticsUtils.positions.FEATURED_CONTENT,
              dimension90: analyticsUtils.dimensions.DIMENSION90,
              creative: item.body
            }
          }
        }
      });
    });
  }

  componentDidMount() {
    const {
      children
    } = this.props; // If there is less than 4 items, the module won't display

    if (children && children.length && !getClientConfigBool(CONFIG_KEYS.NEXT_PUBLIC_FEAT_FLAG_MEASUREMENT)) {
      this.trackVisibleItems(children);
    }
  }

  render() {
    const {
      children,
      title,
      padded = false
    } = this.props;
    const id = uniqueId('featured-content-');
    return /*#__PURE__*/_jsxs(Container, {
      centred: true,
      type: "full",
      className: classNames(style.deckContainer, style.evolved),
      children: [title && /*#__PURE__*/_jsx(Heading, {
        type: 'megasmalldivider',
        className: style.heading,
        id: id,
        children: title
      }), /*#__PURE__*/_jsx(DeckScrollWrapper, {
        contentClassName: style.featuredContentScroll,
        className: style.contentWrapper,
        useCosmeticScrollbar: false,
        eventCategory: analyticsUtils.categories.WHATS_HAPPENING_FEATURED,
        eventAction: analyticsUtils.actions.CLICK,
        children: /*#__PURE__*/_jsx("ol", {
          className: style.deckCardList,
          "aria-labelledby": id,
          role: "list",
          children: React.Children.map(children, child => /*#__PURE__*/React.cloneElement(child, {
            className: style.deckCard,
            onClick: () => this.trackClickEvent(child.props),
            padded
          }))
        })
      })]
    });
  }

}

export default FeaturedContent;